import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Dashboard from '../components/Dashboard'
import AdminSidebar from '../components/AdminSidebar'
import '../styles/Elise.css'

function EliseDashboard() {
  const navigate = useNavigate()
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  useEffect(() => {
    const token = localStorage.getItem('auth_token')
    if (!token) {
      navigate('/admin/login')
    } else {
      setIsAuthenticated(true)
    }
  }, [navigate])

  if (!isAuthenticated) {
    return null
  }

  return (
    <div className="admin-panel">
      <AdminSidebar currentPage="dashboard" />
      <div className="admin-content">
        <Dashboard />
      </div>
    </div>
  )
}

export default EliseDashboard
